//================= [JS] ==========================
import {BaseApi} from '@/common/api/BaseApi';
import { ApiVersionProperties} from '@/types/common/api/api.types';
//================= [EXTERNAL JS] =================

//================= [CLASS] =======================

export class ErrorApi {

  public static api({version = 'v1'}: ApiVersionProperties = {}): string {
    return `${BaseApi.ROOT_URL}/api/${version}/ui-error-report`;
  }

}
